export const configuration = {
  add: 'Dodaj nowy szablon konfiguracji',
  title: 'Szablony konfiguracji',
  noResults: 'Brak danych',
  newTitle: 'Tworzenie nowego szablonu konfiguracji produktu',
  chooseType: 'Wybierz typ produktu',
  chooseSubtype: 'Wybierz podtyp produktu',
  confirmConfiguration:
    'Potwierdź rozpoczęcie szablonu konfiguracji produktu dla',
  productType: 'Typ produktu',
  productSubtype: 'Podtyp produktu',
  newConfigurationName: 'Nazwa nowego szablonu konfiguracji',
  productBrand: 'Marka produktu',
  productModel: 'Model produktu',
  newNamePlaceholder: 'AE 86',
  configurationCreated: 'Konfiguracja została utworzona',
  configurationCreatedPara:
    'Przejść do ekranu modifykacji szablonu konfiguracji?',
  chooseBrand: 'Wybierz markę pojazdu',
  skipBrandChoice: 'Pomiń wybór marki',
  skipBrandModelChoice: 'Pomiń wybór modelu',
  skipSubtypeChoice: 'Pomiń wybór podtypu',
  chooseBrandModel: 'Wybierz model marki pojazdu',
  isDimmensionMode: 'Tryb wymiarów z modelu',
  modelFactorConversion: 'Przelicznik jednostek modelu',
  dimensionModeEnabledInfo:
    'Przełącznik włączony: długości są domyślne. Pole przelicznika jednostek modelu jest wtedy nieaktywne.',
  dimensionModeDisabledInfo:
    'Wyłączony: możesz ręcznie ustawić przelicznik jednostek modelu, który wpływa na długość sceny i obliczenia.',
  dimensionModeEditInfo:
    'Modyfikacja jednostki długości sceny i przelicznika jest dostępna tylko dla szkicu (draft) z uprawnieniem EDIT.',
  filters: {
    all: 'Wszystko',
    productTypes: 'Typ',
    productSubTypes: 'Podtyp',
    brands: 'Marka',
    brandModels: 'Model',
    name: 'Szukaj',
    status: 'Status',
    createdBy: 'Autor',
  },
  errorCreatedConfiguration: 'Nie stworzono szablonu konfiguracji!',
}
